/**
 * Server-side password validation (AUTH-VULN-06)
 * Enforces 8-character minimum — Supabase accepts 6 by default
 */

export interface ValidationResult {
  valid: boolean;
  error?: string;
}

export function validatePassword(password: string): ValidationResult {
  if (!password || password.length === 0) {
    return { valid: false, error: 'Password is required' };
  }
  if (password.length < 8) {
    return { valid: false, error: 'Password must be at least 8 characters' };
  }
  return { valid: true };
}
